(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v2"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.slick-side-h2').slick({
    autoplay: true,
    autoplaySpeed: 5000, // Time in milliseconds (e.g., 5000 = 5 seconds)
    dots: true,          // Show navigation dots
    arrows: true,        // Show next/prev arrows
    infinite: true,      // Loop back to the first slide after the last
    speed: 500,          // Transition speed in milliseconds
    fade: true,          // Use a fade effect instead of a slide
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1
  });
});

  } catch(e) { console.error(e); }
})();
})();
